export default __webpack_public_path__ + "static/media/beep-05.fc9e6561.wav";